import React, { useEffect } from 'react';
import { useHeader } from '../contexts/HeaderContext';

const Reports: React.FC = () => {
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle('Reports');
  }, [setTitle]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
        <p className="mt-1 text-sm text-gray-500">
          View assessment reports and analytics
        </p>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-gray-500">Reports page coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default Reports;
